import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaStar,
  FaFacebookF,
  FaTwitter,
  FaPinterestP,
  FaShareAlt,
  FaLinkedinIn,
} from "react-icons/fa";
import { products } from "../data/products";
import ProductCard from "../components/ProductCard";
import { useStore } from "../context/Storecontext";

const groupedItems = [
  {
    id: 101,
    name: "Shave Brush",
    price: 99,
    oldPrice: 120,
    qty: 1,
    stock: true,
  },
  {
    id: 102,
    name: "Aftershave Lotion",
    price: 80,
    oldPrice: null,
    qty: 1,
    stock: true,
  },
  {
    id: 103,
    name: "White Shave Brush",
    price: 119,
    oldPrice: null,
    qty: 1,
    stock: true,
  },
];

export default function ProductGroupedPage() {
  const product = products[0];
  const [selected, setSelected] = useState({});
  const navigate = useNavigate();
  const { addToCart, addToWishlist } = useStore();
  const related = products.slice(1, 6);

  const toggleSelect = (id) =>
    setSelected((prev) => ({ ...prev, [id]: !prev[id] }));

  const handleAddSelected = () => {
    groupedItems
      .filter((g) => selected[g.id])
      .forEach((g) =>
        addToCart({
          ...product,
          id: g.id,
          name: g.name,
          price: g.price,
          qty: g.qty,
        }),
      );
    navigate("/cart");
  };

  return (
    <div>
      <div
        className="w-full h-32 bg-cover bg-center relative flex items-center p-8 border-b border-gray-100 overflow-hidden"
        style={{ backgroundImage: "url(/img/bg/banner18.jpg)" }}
      >
        <nav className="text-xs text-gray-400 font-medium tracking-wide justify-center items-center m-auto text-center">
          {/* <h2 className="text-2xl text-black font-semibold mb-2">
            Blog 
          </h2> */}
          <Link to="/" className="hover:text-[#43a047] transition-colors">
            Home
          </Link>
          <span className="mx-2 text-gray-300">/</span>
          <span className="text-gray-600">Product grouped</span>
        </nav>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-10">
        <div className="flex flex-col lg:flex-row gap-10">
          {/* Image gallery */}
          <div className="lg:w-1/2">
            <div className="border border-border-color bg-gray-50 mb-3">
              <img
                src={product.img1}
                alt={product.name}
                className="w-full h-80 object-contain"
              />
            </div>
            <div className="flex gap-2">
              {[product.img1, product.img2, product.img1, product.img2].map(
                (img, i) => (
                  <button
                    key={i}
                    className="w-16 h-16 border border-border-color overflow-hidden hover:border-primary"
                  >
                    <img
                      src={img}
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </button>
                ),
              )}
            </div>
          </div>

          {/* Info */}
          <div className="lg:w-1/2">
            <h1 className="text-2xl font-bold text-dark mb-2">
              {product.name}
            </h1>
            <div className="flex items-center gap-2 mb-3">
              <div className="flex gap-0.5">
                {[1, 2, 3, 4, 5].map((s) => (
                  <FaStar key={s} className="text-yellow-400" size={13} />
                ))}
              </div>
              <span className="text-xs text-gray-400">(1 customer review)</span>
            </div>
            <div className="flex gap-3 items-center mb-4">
              <span className="text-2xl font-bold text-primary">
                ${product.price}.00
              </span>
              <span className="text-gray-400 line-through">
                ${product.oldPrice}.00
              </span>
            </div>
            <p className="text-sm text-gray-500 leading-relaxed mb-6">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam
              fringilla augue nec dolor auctor. Donec non est ac libero
              vulputate rutrum. Morbi ornare lectus mollis, ipsum gravida
              semper.
            </p>

            <table className="w-full text-sm mb-4 border border-border-color">
              <tbody>
                {groupedItems.map((g) => (
                  <tr
                    key={g.id}
                    className="border-b border-border-color last:border-b-0"
                  >
                    <td className="p-3 w-8">
                      <input
                        type="checkbox"
                        checked={!!selected[g.id]}
                        onChange={() => toggleSelect(g.id)}
                        className="accent-primary"
                      />
                    </td>
                    <td className="p-3 font-medium text-dark hover:text-primary cursor-pointer">
                      {g.name}
                    </td>
                    <td className="p-3 text-right">
                      {g.oldPrice && (
                        <span className="text-gray-400 line-through text-xs mr-2">
                          ${g.oldPrice}.00
                        </span>
                      )}
                      <span className="text-primary font-semibold">
                        ${g.price}.00
                      </span>
                      <div className="text-xs text-green-600 mt-0.5">
                        In Stock
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <button
              onClick={handleAddSelected}
              className="bg-primary text-white text-sm font-semibold px-6 py-2.5 hover:bg-primary-dark transition-colors mb-4"
            >
              Add To Cart
            </button>

            <div className="flex flex-col gap-2 text-sm mb-4">
              <button
                onClick={() => addToWishlist(product)}
                className="text-left text-gray-500 hover:text-primary"
              >
                + Add to Wishlist
              </button>
              <a href="#" className="text-gray-500 hover:text-primary">
                + Compare
              </a>
            </div>

            <p className="text-sm text-gray-500 mb-3">
              Category: <span className="text-dark">{product.category}</span>
            </p>

            <div className="flex gap-2">
              {[
                FaFacebookF,
                FaTwitter,
                FaPinterestP,
                FaShareAlt,
                FaLinkedinIn,
              ].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-8 h-8 border border-border-color flex items-center justify-center text-gray-400 hover:text-white hover:bg-primary hover:border-primary transition-colors"
                >
                  <Icon size={12} />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="mt-12">
          <div className="flex gap-6 border-b border-border-color mb-6">
            <button className="text-sm font-semibold text-primary border-b-2 border-primary pb-3">
              Description
            </button>
            <button className="text-sm font-semibold text-gray-500 pb-3">
              Specification
            </button>
            <button className="text-sm font-semibold text-gray-500 pb-3">
              Reviews (1)
            </button>
          </div>
          <p className="text-sm text-gray-500 leading-relaxed mb-4">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam
            fringilla augue nec dolor auctor. Donec non est ac libero vulputate
            rutrum. Morbi ornare lectus mollis, ipsum gravida semper, nec
            commodo augue nisi non neque. Lorem ipsum dolor sit amet,
            consectetur adipiscing elit. Sed tempor, lorem et placerat
            vestibulum, metas nec posuere nisi, in.
          </p>
          <p className="text-sm text-gray-500 leading-relaxed">
            Pellentesque aliquet, sem eget lacinia ultrices, ipsam metas feugiat
            sem, quis fermentum turpis eros eget velit. Donec ac tempus arcu.
            Nam fringilla augue nec dolor auctor. Donec non est ac libero
            vulputate rutrum.
          </p>
        </div>

        {/* Related */}
        <div className="mt-12">
          <h3 className="text-xl font-bold text-dark mb-6 text-center">
            Related Products
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-5 gap-4">
            {related.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
